import enToBreakdown from './en-to-breakdown.json';
import peopleFormTabEmployment from './en-people-form-tab-employment.json';
import peopleSideNavigation from './en-people-side-navigation.json';
import peopleModule from './en-people-module.json';
import peopleModuleBulkActionsArchive from './en-people-module-bulk-actions-archive.json';
import peopleModuleBulkActionsAssignJobTitle from './en-people-module-bulk-actions-assign-job-title.json';
import peopleModuleBulkActionsForm from './en-people-module-bulk-actions-form.json';
import peopleModuleBulkActionsReinstate from './en-people-module-bulk-actions-reinstate.json';
import peopleModuleFilters from './en-people-module-filters.json';
import peopleFormTabJournalsTeamPerformanceUpsellBanner from './en-people-form-tab-journals-team-performance-upsell-banner.json';

// people nested modules
import EmploymentEnd from '@/modules/people/modules/employment-end/locales/en.json';
import EmployeeArchiveFailure from '@/modules/people/modules/employee-archive/locales/en.json';
import Payroll from '@/modules/people/modules/payroll/locales/en.json';
import PayRateAwareness from '@/modules/people/modules/pay-rate-awareness/locales/en.json';
import PayCalendar from '@/modules/people/modules/pay-calendar/locales/en.json';

const combined = {
  people: {
    ...enToBreakdown.people,
    ...peopleFormTabEmployment,
    ...peopleSideNavigation,
    ...peopleModule,
    ...peopleModuleBulkActionsArchive,
    ...peopleModuleBulkActionsAssignJobTitle,
    ...peopleModuleBulkActionsForm,
    ...peopleModuleBulkActionsReinstate,
    ...peopleModuleFilters,
    ...peopleFormTabJournalsTeamPerformanceUpsellBanner,
    modules: {
      ...EmploymentEnd,
      ...EmployeeArchiveFailure,
      ...Payroll,
      ...PayRateAwareness,
      ...PayCalendar,
    },
  },
};

export default combined;
